var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoodStroke5 = function SvgMoodStroke5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54.442,
    height: 54.442,
    viewBox: "0 0 54.442 54.442",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M17.237,44.248A27.229,27.229,0,1,1,2.26,58.734,27.118,27.118,0,0,1,17.237,44.248Zm19.476,3.464A23.835,23.835,0,1,0,49.38,60.817,23.764,23.764,0,0,0,36.713,47.712ZM27.221,71.259H13.478a13.856,13.856,0,0,0,8.657,11.182l0,0A13.835,13.835,0,0,0,40.1,74.653l0-.005a13.827,13.827,0,0,0,.721-2.488q.085-.45.142-.9H27.221Zm-15.54-3.384h31.08a1.693,1.693,0,0,1,1.693,1.693A17.223,17.223,0,0,1,43.3,75.79a1.711,1.711,0,0,1-.085.213A17.248,17.248,0,0,1,21,85.642a1.7,1.7,0,0,1-.216-.085,17.227,17.227,0,0,1-10.8-15.989,1.693,1.693,0,0,1,1.693-1.693Z",
    transform: "translate(0 -42.345)",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoodStroke5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moodStroke5.1e1c7671.svg";
export { ForwardRef as ReactComponent };